module.exports = __webpack_public_path__ + "static/media/companynewsImg2.9b3db076.jpg";